import React from 'react';
import { Outlet } from 'react-router-dom';
import { usePermissions } from '../custom_hooks/permissions';
import NoAccess from '../pages/no-access';

interface Props {
    feature: string;
}

const ProtectedFeatureRoute: React.FC<Props> = ({ feature }) => {
    const { canView } = usePermissions();
    if (canView(feature)) {
        return <Outlet />;
    }
    return <NoAccess />;
};

export default ProtectedFeatureRoute;
